'use client';

/* eslint-disable @next/next/no-img-element -- The disclosure icon does not need the stateful shared Image fallback. */

import { useState } from 'react';
import { usePageMetadata } from '@/shared/hooks/usePageMetadata';

interface FooterPageTextProps {
  buttonClassName: string;
  contentClassName: string;
  indicatorClassName: string;
  wrapperClassName: string;
}

export const FooterPageText = ({
  buttonClassName,
  contentClassName,
  indicatorClassName,
  wrapperClassName,
}: FooterPageTextProps) => {
  const [expanded, setExpanded] = useState(false);
  const { data, error, isLoading } = usePageMetadata();

  if (isLoading || error || !data?.pageText) {
    return null;
  }

  return (
    <section className={wrapperClassName} data-expanded={expanded}>
      <div
        className={contentClassName}
        dangerouslySetInnerHTML={{ __html: data.pageText }}
      />
      <button
        aria-expanded={expanded}
        className={buttonClassName}
        onClick={() => setExpanded((current) => !current)}
        type="button"
      >
        <img
          alt=""
          aria-hidden="true"
          className={indicatorClassName}
          height={20}
          loading="lazy"
          src="/images/icons/indicator-lang.svg"
          width={20}
        />
      </button>
    </section>
  );
};
